/**
 * ToastManager — Lightweight toast notification system.
 * Emits events that the ToastContainer component listens to.
 */

import eventBus from './EventBus';

let toastId = 0;

const toast = {
  show(message, { type = 'info', duration = 3000, icon = null } = {}) {
    toastId += 1;
    eventBus.emit('toast:show', { id: toastId, message, type, duration, icon });
    return toastId;
  },
  success(message, opts = {}) {
    return this.show(message, { type: 'success', ...opts });
  },
  error(message, opts = {}) {
    return this.show(message, { type: 'error', duration: 5000, ...opts });
  },
  info(message, opts = {}) {
    return this.show(message, { type: 'info', ...opts });
  },
  warn(message, opts = {}) {
    return this.show(message, { type: 'warn', duration: 4000, ...opts });
  },
};

export default toast;
